import { Box, Flex } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const PromoItemSkeleton = () => {
  return (
    <Box border="1px solid var(--color-neutral20)" borderRadius="8px" padding="12px" mb="8px">
      <Flex gap="8px" alignItems="center" mb="12px">
        <SkeletonComponent height="16px" width="16px" borderRadius="50%" />
        <SkeletonComponent height="14px" width="100px" />
      </Flex>
      <Flex flexDirection="column" gap="8px">
        <Iteration
          items={[1, 2]}
          render={(item) => (
            <Box key={item} padding="8px" borderRadius="6px" border="1px solid var(--color-neutral10)">
              <Flex alignItems="center" gap="8px" mb="6px">
                <SkeletonComponent height="20px" width="50px" borderRadius="4px" />
                <SkeletonComponent height="20px" width="80px" borderRadius="4px" />
              </Flex>
              <SkeletonComponent height="14px" width="70%" mb="4px" />
              <SkeletonComponent height="12px" width="50%" />
            </Box>
          )}
        />
      </Flex>
    </Box>
  );
};

const PromoContentSkeleton = () => {
  return (
    <Box className={styles['content__container']}>
      <Iteration
        items={[1, 2, 3]}
        render={(item) => <PromoItemSkeleton key={item} />}
      />
    </Box>
  );
};

export default PromoContentSkeleton;
